import { useState } from 'react'

import { Button } from './Button'
import { Field } from './Field'
import { Stack } from './Stack'
import { Text } from './Text'

export function ConfirmAction({
  word,
  label,
  action,
  body,
  error,
  pending = false,
  onConfirm,
}: {
  word: string
  label: string
  action: string
  body?: string | undefined
  error?: string | undefined
  pending?: boolean
  onConfirm: () => void
}) {
  const [typed, setTyped] = useState('')
  const armed = typed.trim() === word

  return (
    <Stack gap="md">
      {body ? (
        <Text role="caption" tone="muted" measure>
          {body}
        </Text>
      ) : null}

      <Field label={label} {...(error ? { error } : {})}>
        {(control) => (
          <input
            {...control}
            value={typed}
            autoComplete="off"
            onChange={(event) => setTyped(event.target.value)}
          />
        )}
      </Field>

      <Button variant="danger" disabled={!armed || pending} onClick={onConfirm}>
        {action}
      </Button>
    </Stack>
  )
}
